import React from 'react';
import { BlockDataForm, SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import BrandView from './View';
import Schema, { DEFAULTS } from './EditSchema';

const migrateLegacyRowColors = (data) => {
  const next = { ...data };

  ['row1', 'row2', 'row3'].forEach((row) => {
    const legacyKey = `${row}Color`;
    const leftKey = `${row}ColorLeft`;
    const rightKey = `${row}ColorRight`;
    const thirdKey = `${row}ColorThird`;

    if (data[legacyKey]) {
      if (!data[leftKey]) {
        next[leftKey] = data[legacyKey];
      }

      if (!data[rightKey]) {
        next[rightKey] = data[legacyKey];
      }

      if (!data[thirdKey]) {
        next[thirdKey] = data[legacyKey];
      }
    }
  });

  return next;
};

const BrandEdit = (props) => {
  const { data = {}, block, onChangeBlock, selected } = props;

  React.useEffect(() => {
    let next = { ...DEFAULTS, ...data };
    next = migrateLegacyRowColors(next);

    if (JSON.stringify(next) !== JSON.stringify(data)) {
      onChangeBlock(block, next);
    }
  }, []);

  const schema = Schema({ ...props, data });

  return (
    <>
      <BrandView {...props} isEditMode />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          title={schema.title}
          schema={schema}
          formData={data}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(BrandEdit);
